if (!customElements.get('predictive-search')) {
    class PredictiveSearch extends HTMLElement {
        constructor() {
            super();
            this.cachedResults = {};
            this.input = this.querySelector('.js-search-input');
            this.predictiveSearchResults = this.querySelector('predictive-search-results');
            this.resultsContainer = this.predictiveSearchResults.querySelector('.predictive-search-results__content');

            this.productTypeSelect = this.querySelector('.js-search-product-types');
            this.productTypeInput = document.getElementById('product_type_input');
            this.resetButton = this.querySelector('.js-search-reset');
            this.focussedResult = undefined;
    
            this.abortController = null;
            this.currentQuery = '';
            this.loaderStartTime = 0;
            this.minLoaderTime = 400;

        }

        /**
         * Triggers when the web component is removed from the DOM
         */
        disconnectedCallback() {
            this.close(true);
        }

        /**
         * Triggers when the web component is add from the DOM
         */

        connectedCallback() {
            this.init();
        }

        init() {
            const form = this.querySelector('form');
            form.addEventListener('submit', this.onFormSubmit.bind(this));
            this.input.addEventListener(
                'input',
                debounce(event => {this.onChange(event);}, 300).bind(this)
            );
            this.input.addEventListener('focus', this.onFocus.bind(this));
            this.addEventListener('keydown', this.onKeyPress.bind(this));
            this.addEventListener('focusout', this.onFocusOut.bind(this));
            if (this.productTypeSelect) {
                this.productTypeSelect.addEventListener('change', this.handleProductTypeChange.bind(this));
            }
             this.addEventListener('click', (evt) => {
            const submitBtn = evt.target.closest('.js-submit .js-search-link');
                if (submitBtn) {
                form.submit(); // force submit
                }
            });
        }

        showLoader() {
if          (!this.loader) this.loader = this.querySelector('.predictive-search-loader');
            if (!this.loader) return;
            this.loaderStartTime = Date.now();

            this.loader.classList.remove('hidden');
        }

        hideLoader() {
            if (!this.loader) return;

            const elapsed = Date.now() - this.loaderStartTime;
            const delay = Math.max(this.minLoaderTime - elapsed, 0);

            setTimeout(() => {
                this.loader.classList.add('hidden');
            }, delay);
        }


        onKeyPress(event) {
            if (!this.hasAttribute('open')) return;
            const resultsArray = Array.from(
                this.querySelectorAll('.predictive-search__item')
            );
            if (!resultsArray.length) return;

            switch (event.keyCode) {
                case 38:
                    event.preventDefault();
                    // Up Arrow
                    this.focusResult(false, event, resultsArray);
                    break;
                case 40:
                    // Down arrow
                    this.focusResult(true, event, resultsArray);
                    break;
                default:
                    break;
            }
        }

        focusResult(nextResult, event, resultsArray) {
            if (resultsArray.length === 1) return;
            const currentIndex = resultsArray.indexOf(this.focussedResult);
            let targetIndex = nextResult
                ? currentIndex + 1
                : currentIndex - 1;
            if (!resultsArray[targetIndex]) {
                targetIndex = nextResult ? 0 : resultsArray.length - 1;
            }
            event.preventDefault();
            if (this.focussedResult) {
        this.focussedResult.classList.remove('is-highlighted');
        this.focussedResult.setAttribute('aria-selected', 'false');
    }

    // Set new highlight and aria-selected
    this.focussedResult = resultsArray[targetIndex];
    this.focussedResult.classList.add('is-highlighted');
    this.focussedResult.setAttribute('aria-selected', 'true');

    // Update input and activedescendant
    this.input.value = this.focussedResult.innerText;
    this.input.setAttribute('aria-activedescendant', this.focussedResult.id || '');
        }


        getQuery() {
            return this.input.value.trim();
        }

        hasQuery() {
            return !!this.getQuery().length;
        }

        onChange() {
            const searchTerm = this.getQuery();

            if (!this.hasQuery()) {
                this.close(true);
                return;
            }

            this.getSearchResults(searchTerm);
        }

        onFormSubmit(evt) {
            if (
                !this.getQuery().length || this.querySelector('.predictive-search__item[aria-selected="true"]:not(.js-submit)')
            ) {
                evt.preventDefault();
            }
        }

        onFocus() {
            const searchTerm = this.getQuery();

            if (!this.hasQuery()) return;

            if (this.getAttribute('results') === 'true') {
                this.open();
            } else {
                this.getSearchResults(searchTerm);
            }
        }

        onFocusOut() {
            setTimeout(() => {
                if (!this.contains(document.activeElement)) this.close();
            });
        }


        /**
     * Handles a change of product type
     * @param {object} evt - Event object.
     */
        handleProductTypeChange(evt) {
            this.productTypeInput.value = evt.detail.selectedValue;
            const query = this.getQuery();
            if (query.length > 0) {
                this.getSearchResults(query);
            }
        }


        /**
        * Gets the results for a search term.
        * @param {string} searchTerm - Search query.
        */
        async getSearchResults(searchTerm) {

            this.currentQuery = searchTerm;
            if (this.abortController) {
                this.abortController.abort();
            }
            this.abortController = new AbortController();
            const signal = this.abortController.signal;

            this.showLoader();
            if (!searchTerm.length) {
                this.close(true);
                return;
            }



            let searchFields = 'title,product_type,variants.title,vendor';
            if (theme.searchQueryStrings.pSearchIncludeSkus) searchFields += ',variants.sku';
            if (theme.searchQueryStrings.pSearchIncludeTags) searchFields += ',tag';

            let searchParams = '';
            if (this.productTypeInput && this.productTypeInput.value !== '') {
                searchParams = `q=product_type:${encodeURIComponent(this.productTypeInput.value)} AND ${encodeURIComponent(searchTerm)}`;
            } else {
                searchParams = `q=${encodeURIComponent(searchTerm)}`;
            }

            searchParams += `&${encodeURIComponent('resources[limit]')}=${theme.searchQueryStrings.pSearchLimit}`;
            searchParams += `&${encodeURIComponent('resources[limit_scope]')}=${theme.searchQueryStrings.pSearchLimitScope
                }`;
            searchParams += `&${encodeURIComponent('resources[options][fields]')}=${searchFields}`;
            searchParams += '&section_id=predictive-search';


            const queryKey = searchParams.replace(' ', '-').toLowerCase();
            if (this.cachedResults[queryKey]) {
                this.renderSearchResults(this.cachedResults[queryKey]);
                this.hideLoader();
                return;
            }


            try {
                const response = await fetch(`${theme.routes.predictive_search_url}?${searchParams}`, { signal });
                if (!response.ok) throw new Error(response.status);

                const tmpl = document.createElement('template');
                tmpl.innerHTML = await response.text();

                const resultsEl = tmpl.content.querySelector('#shopify-section-predictive-search');
                const resultsMarkup = resultsEl.innerHTML.replace(/psearch/g, this.input.id);
                this.cachedResults[queryKey] = resultsMarkup;
                this.renderSearchResults(resultsMarkup);
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error(error);
                }
            } finally {
                this.hideLoader();
            }

        }


        populateSearchResults(html = '') {
            this.resultsContainer.innerHTML = html;
        }

        renderSearchResults(resultsMarkup) {
            this.populateSearchResults(resultsMarkup);
            this.setAttribute('results', true);
            this.open();
        }

        open() {
            this.focussedResult = undefined;
            this.input.setAttribute('aria-expanded', true);
            this.setAttribute('open', true);

            if (this.resetButton) {
                this.resetButton.hidden = false;
                this.resetBtnClickHandler = this.resetBtnClickHandler || (() => this.close(true));
                this.resetButton.addEventListener('click', this.resetBtnClickHandler);
            }

        }

        close(clearSearchTerm = false) {

            this.hideLoader();
            if (this.resetButton && this.resetBtnClickHandler) {
                this.resetButton.hidden = true;
                this.resetButton.removeEventListener('click', this.resetBtnClickHandler);
            }

            if (clearSearchTerm) {
                this.input.value = '';
                this.removeAttribute('open');
                this.removeAttribute('results');
                this.input.focus();
                requestAnimationFrame(() => {
                    this.populateSearchResults();
                });
            }



            this.focussedResult = undefined;

            const selected = this.querySelector('[aria-selected="true"]');
            if (selected) selected.setAttribute('aria-selected', false);

            this.removeAttribute('open');
            this.input.setAttribute('aria-activedescendant', '');
            this.input.setAttribute('aria-expanded', false);

        }


    }
    customElements.define('predictive-search', PredictiveSearch);
}
